


























































































import { Meta } from "@/store/meta"
import { Component } from "vue-property-decorator"
import { Server } from '@/store/server'
import { getModule } from "vuex-module-decorators"
import { mixins } from "vue-class-component"
import { DateTime } from "@/mixins/datetime"
@Component({
})
export default class Broadcast extends mixins(DateTime) {

  convertText(text: string, textLimit = 20){
    if (text.length > textLimit) {
      let shortText = ''
      shortText = text.substr(0, textLimit)
      shortText += '...'
      return shortText
    } else {
      return text
    }
  }

  isReady = false
  loading = false

  get isDisplayLoading() {
    return this.loading
  }

  get total() {
    return this.server.BroadcastMessagesHistoryData.listing.total
  }

  get perPage() {
    return this.server.BroadcastMessagesHistoryData.listing.limit
  }

  async mounted() {
    this.loading = true
    try {
      if (this.xChannelServices.length == 0) {
        await this.server.getBoccoChannel()
      }
      await this.server.getBroadcastMessagesHistory()
    } catch (e) {
      return
    }finally{
      this.loading = false
    }
    this.isReady = true
  }
  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }

  get xChannelServices() {
    const channel = getModule(Server).boccoChannel
    return channel == null ? [] : channel.services
  }

  channelInfo(uuid: string) {
    const matchedChannels = this.xChannelServices.filter( channel => channel.uuid == uuid)
    if (matchedChannels.length == 0) {
      this.server.getBoccoChannel()
      return "Unknown"
    } else {
      return matchedChannels[0].name
    }
  }

  get broadcastEntries(){
    return this.server.BroadcastMessagesHistoryData.messages
  }

  detailLink(id: string){
    this.$router.push({ path: '/message-histories/' + id });
  }

  async onPageChanged(page: number) {
    const index = page - 1
    this.loading = true
    await this.server.getBroadcastMessagesHistory(index * this.perPage)
    this.loading = false
  }

}
